import React from 'react'
import { MessageBox, Link } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import { pageErrorState } from '../recoil/state/page'

const ErrorFeedback = () => {
  const intl = useIntl()

  const { error, severity } = useRecoilValue(pageErrorState)
  const handleClickReload = () => {
    location.reload()
  }

  return (
    <>
      {error && (
        <MessageBox variant={severity}>
          <span>{error}</span>{' '}
          <Link onClick={handleClickReload}>
            {intl.formatMessage({ id: 'Load.Common.RealoadPage' })}
          </Link>
        </MessageBox>
      )}
    </>
  )
}

export default ErrorFeedback
